export var CompareState;
(function (CompareState) {
    CompareState[CompareState["CompareFares"] = 0] = "CompareFares";
    CompareState[CompareState["FullFareConditions"] = 1] = "FullFareConditions";
})(CompareState || (CompareState = {}));
